var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoUnblended(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "220.00006px",
    height: "52px",
    viewBox: "0 0 220.00006 52",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g25",
    transform: "translate(57.055054 16.343079)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1.16824C0 0.467428 0.467232 0 1.16776 0L3.44479 0C4.14532 0 4.61255 0.467428 4.61255 1.16824L4.61255 13.9309C4.61255 16.6473 5.66333 17.8445 7.96993 17.8445C10.2759 17.8445 11.3273 16.6473 11.3273 13.9309L11.3273 1.16824C11.3273 0.467428 11.7945 0 12.4944 0L14.7721 0C15.4726 0 15.9392 0.467428 15.9392 1.16824L15.9392 14.3398C15.9392 19.6551 12.0568 21.4078 7.96993 21.4078C3.88246 21.4078 0 19.6551 0 14.3398L0 1.16824Z",
    id: "path27",
    fill: "#3352AB",
    fillRule: "evenodd",
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g29",
    transform: "translate(77.080444 16.3432)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9103 19.8596C15.9103 20.5604 15.4431 21.0278 14.7425 21.0278L12.0863 21.0278C11.531 21.0278 11.0638 20.7063 10.8305 20.2395L4.61254 7.85561L4.61254 19.8596C4.61254 20.5604 4.14531 21.0278 3.44478 21.0278L1.16775 21.0278C0.467225 21.0278 0 20.5604 0 19.8596L0 1.16826C0 0.467427 0.467225 0 1.16775 0L3.8831 0C4.4371 0 4.90433 0.320842 5.13826 0.788269L11.2978 13.142L11.2978 1.16826C11.2978 0.467427 11.765 2.78098e-05 12.4655 2.78098e-05L14.7425 2.78098e-05C15.4431 0 15.9103 0.467427 15.9103 1.16826L15.9103 19.8596Z",
    id: "path31",
    fill: "#3352AB",
    fillRule: "evenodd",
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g33",
    transform: "translate(97.36792 16.3432)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5683 14.4272C10.5683 12.6752 9.66344 11.9737 7.44425 11.9737L4.64215 11.9737L4.64215 17.4356L7.5323 17.4356C9.66344 17.4356 10.5683 16.7637 10.5683 14.9821L10.5683 14.4272ZM10.5099 5.92868C10.5099 4.17663 9.60495 3.56323 7.38577 3.56323L4.64215 3.56323L4.64215 8.76153L7.50274 8.76153C9.60495 8.76153 10.5099 8.17772 10.5099 6.42503L10.5099 5.92868ZM1.16776 21.0278C0.467232 21.0278 0 20.5604 0 19.8596L0 1.16826C0 0.467427 0.467232 0 1.16776 0L7.21093 0C12.3196 0 15.1224 1.66461 15.1224 5.78272L15.1224 6.16271C15.1224 8.17773 14.3923 9.52086 13.1082 10.3676C14.4219 11.2729 15.1809 12.5871 15.1809 14.6902L15.1809 15.1576C15.1809 19.3336 12.3781 21.0278 7.26941 21.0278L1.16776 21.0278Z",
    id: "path35",
    fill: "#3352AB",
    fillRule: "evenodd",
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g37",
    transform: "translate(116.19641 16.3432)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.166 19.8596C13.166 20.5604 12.6988 21.0278 11.9983 21.0278L1.16776 21.0278C0.467233 21.0278 0 20.5604 0 19.8596L0 1.16826C0 0.467427 0.467233 0 1.16776 0L3.4448 0C4.14531 0 4.61255 0.467427 4.61255 1.16826L4.61255 17.4356L11.9983 17.4356C12.6988 17.4356 13.166 17.9024 13.166 18.6039L13.166 19.8596Z",
    id: "path39",
    fill: "#3352AB",
    fillRule: "evenodd",
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g41",
    transform: "translate(132.13446 16.3432)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7573 19.8596C12.7573 20.5604 12.2901 21.0278 11.5895 21.0278L1.16776 21.0278C0.467232 21.0278 0 20.5604 0 19.8596L0 1.16826C0 0.467427 0.467232 0 1.16776 0L11.56 0C12.2611 0 12.7284 0.467427 12.7284 1.16826L12.7284 2.42393C12.7284 3.12477 12.2611 3.59219 11.56 3.59219L4.61256 3.59219L4.61256 8.67408L10.9764 8.67408C11.6769 8.67408 12.1442 9.14087 12.1442 9.8417L12.1442 11.0099C12.1442 11.7114 11.6769 12.1782 10.9764 12.1782L4.61256 12.1782L4.61256 17.4356L11.5895 17.4356C12.2901 17.4356 12.7573 17.9024 12.7573 18.6039L12.7573 19.8596Z",
    id: "path43",
    fill: "#3352AB",
    fillRule: "evenodd",
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g45",
    transform: "translate(148.24744 16.3432)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9103 19.8596C15.9103 20.5604 15.4431 21.0278 14.7425 21.0278L12.0863 21.0278C11.5311 21.0278 11.0638 20.7063 10.8305 20.2395L4.61256 7.85561L4.61256 19.8596C4.61256 20.5604 4.14533 21.0278 3.4448 21.0278L1.16776 21.0278C0.467232 21.0278 0 20.5604 0 19.8596L0 1.16826C0 0.467427 0.467232 0 1.16776 0L3.88311 0C4.4371 0 4.90433 0.320842 5.13826 0.788269L11.2978 13.142L11.2978 1.16826C11.2978 0.467427 11.765 2.78098e-05 12.4655 2.78098e-05L14.7425 2.78098e-05C15.4431 0 15.9103 0.467427 15.9103 1.16826L15.9103 19.8596Z",
    id: "path47",
    fill: "#3352AB",
    fillRule: "evenodd",
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g49",
    transform: "translate(168.53522 16.343262)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2393 7.41774C11.2393 4.84786 10.2174 3.59216 7.736 3.59216L4.61255 3.59216L4.61255 17.4356L7.736 17.4356C10.2174 17.4356 11.2393 16.1793 11.2393 13.6094L11.2393 7.41774ZM1.16776 21.0278C0.467232 21.0278 0 20.5604 0 19.8595L0 1.16824C0 0.466788 0.467232 0 1.16776 0L7.9693 0C12.3486 0 15.8518 1.48908 15.8518 7.06734L15.8518 13.9894C15.8518 19.5676 12.3486 21.0278 7.9693 21.0278L1.16776 21.0278Z",
    id: "path51",
    fill: "#3352AB",
    fillRule: "evenodd",
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g53",
    transform: "translate(188.03497 16.3432)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7573 19.8596C12.7573 20.5604 12.2901 21.0278 11.5895 21.0278L1.16776 21.0278C0.467232 21.0278 0 20.5604 0 19.8596L0 1.16826C0 0.467427 0.467232 0 1.16776 0L11.56 0C12.2611 0 12.7284 0.467427 12.7284 1.16826L12.7284 2.42393C12.7284 3.12477 12.2611 3.59219 11.56 3.59219L4.61256 3.59219L4.61256 8.67408L10.9764 8.67408C11.6769 8.67408 12.1442 9.14087 12.1442 9.8417L12.1442 11.0099C12.1442 11.7114 11.6769 12.1782 10.9764 12.1782L4.61256 12.1782L4.61256 17.4356L11.5895 17.4356C12.2901 17.4356 12.7573 17.9024 12.7573 18.6039L12.7573 19.8596Z",
    id: "path55",
    fill: "#3352AB",
    fillRule: "evenodd",
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g57",
    transform: "translate(204.1482 16.343262)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2393 7.41774C11.2393 4.84786 10.2174 3.59216 7.736 3.59216L4.61255 3.59216L4.61255 17.4356L7.736 17.4356C10.2174 17.4356 11.2393 16.1793 11.2393 13.6094L11.2393 7.41774ZM1.16776 21.0278C0.467232 21.0278 0 20.5604 0 19.8595L0 1.16824C0 0.466788 0.467232 0 1.16776 0L7.96931 0C12.3486 0 15.8518 1.48908 15.8518 7.06734L15.8518 13.9894C15.8518 19.5676 12.3486 21.0278 7.96931 21.0278L1.16776 21.0278Z",
    id: "path59",
    fill: "#3352AB",
    fillRule: "evenodd",
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g61",
    transform: "translate(57.055603 44.546875)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.09199 0.844195C5.09199 1.08786 4.92939 1.25119 4.68517 1.25119L3.33361 1.25119L3.33361 6.91433C3.33361 7.158 3.17101 7.32066 2.92679 7.32066L2.13436 7.32066C1.89014 7.32066 1.72754 7.158 1.72754 6.91433L1.72754 1.25119L0.40682 1.25119C0.162599 1.25119 0 1.08786 0 0.844195L0 0.406997C0 0.16266 0.162599 0 0.40682 0L4.68517 0C4.92939 0 5.09199 0.16266 5.09199 0.406997L5.09199 0.844195Z",
    id: "path63",
    fill: "#65B731",
    fillRule: "evenodd",
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g65",
    transform: "translate(63.183655 44.54712)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.63822 2.22656C3.63822 1.61639 3.35351 1.25055 2.59129 1.25055L1.60541 1.25055L1.60541 3.51761L2.59129 3.51761C3.35351 3.51761 3.63822 3.15177 3.63822 2.54226L3.63822 2.22656ZM5.2848 6.76129C5.43712 7.0969 5.27451 7.32066 4.90882 7.32066L4.08555 7.32066C3.87217 7.32066 3.67937 7.1882 3.60803 6.98569L2.80467 4.74819C2.69285 4.75848 2.54053 4.75848 2.4287 4.75848L1.60542 4.75848L1.60542 6.91366C1.60542 7.158 1.44282 7.32066 1.19925 7.32066L0.406174 7.32066C0.162599 7.32066 0 7.158 0 6.91366L0 0.406329C0 0.16266 0.162599 0 0.406174 0L2.50004 0C4.02449 0 5.24431 0.468067 5.24431 2.25741L5.24431 2.51137C5.24431 3.49767 4.87798 4.06733 4.29892 4.38236L5.2848 6.76129Z",
    id: "path67",
    fill: "#65B731",
    fillRule: "evenodd",
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g69",
    transform: "translate(69.237 44.546814)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.03052 4.93143L3.11997 1.63757L2.20874 4.93143L4.03052 4.93143ZM6.08158 6.88346C6.16256 7.158 6.03081 7.32133 5.75638 7.32133L4.89196 7.32133C4.6786 7.32133 4.49543 7.18887 4.44466 6.9754L4.17023 6.0097L1.93433 6.0097L1.65991 6.9754C1.60913 7.18887 1.42597 7.32133 1.21324 7.32133L0.348826 7.32133C0.0744019 7.32133 -0.0573477 7.158 0.0236285 6.88346L1.96518 0.386418C2.03588 0.153038 2.2396 0 2.48319 0L3.6728 0C3.91637 0 4.11946 0.153038 4.1908 0.386418L6.08158 6.88346Z",
    id: "path71",
    fill: "#65B731",
    fillRule: "evenodd",
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g73",
    transform: "translate(76.02869 44.41443)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.54958 2.49145C5.54958 2.73512 5.38699 2.89845 5.14276 2.89845L4.29956 2.89845C4.08619 2.89845 3.94351 2.7557 3.94351 2.54224L3.94351 2.52232C3.94351 1.71862 3.61832 1.2409 2.77511 1.2409C1.97176 1.2409 1.60607 1.65819 1.60607 2.60333L1.60607 4.98291C1.60607 5.92869 1.97176 6.34531 2.77511 6.34531C3.57783 6.34531 3.94351 5.92869 3.94351 4.98291L3.94351 4.81958C3.94351 4.60678 4.08619 4.46403 4.29956 4.46403L5.14276 4.46403C5.38699 4.46403 5.54958 4.62669 5.54958 4.87103L5.54958 5.12499C5.54958 6.9754 4.19802 7.58558 2.77511 7.58558C1.35157 7.58558 0 6.9754 0 5.12499L0 2.47088C0 0.630755 1.35157 0 2.77511 0C4.19802 0 5.54958 0.630755 5.54958 2.47088L5.54958 2.49145Z",
    id: "path75",
    fill: "#65B731",
    fillRule: "evenodd",
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g77",
    transform: "translate(82.66467 44.41443)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.54958 2.49145C5.54958 2.73512 5.38699 2.89845 5.14276 2.89845L4.29956 2.89845C4.08619 2.89845 3.94351 2.7557 3.94351 2.54224L3.94351 2.52232C3.94351 1.71862 3.61832 1.2409 2.77511 1.2409C1.97176 1.2409 1.60607 1.65819 1.60607 2.60333L1.60607 4.98291C1.60607 5.92869 1.97176 6.34531 2.77511 6.34531C3.57783 6.34531 3.94351 5.92869 3.94351 4.98291L3.94351 4.81958C3.94351 4.60678 4.08619 4.46403 4.29956 4.46403L5.14276 4.46403C5.38699 4.46403 5.54958 4.62669 5.54958 4.87103L5.54958 5.12499C5.54958 6.9754 4.19802 7.58558 2.77511 7.58558C1.35157 7.58558 0 6.9754 0 5.12499L0 2.47088C0 0.630755 1.35157 0 2.77511 0C4.19802 0 5.54958 0.630755 5.54958 2.47088L5.54958 2.49145Z",
    id: "path79",
    fill: "#65B731",
    fillRule: "evenodd",
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g81",
    transform: "translate(89.55463 44.546814)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.82178 6.91433C1.82178 7.158 1.63735 7.32133 1.36032 7.32133L0.461461 7.32133C0.184438 7.32133 0 7.158 0 6.91433L0 0.406997C0 0.162688 0.184438 0 0.461461 0L1.36032 0C1.63735 0 1.82178 0.162688 1.82178 0.406997L1.82178 6.91433Z",
    id: "path83",
    fill: "#65B731",
    fillRule: "evenodd",
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g85",
    transform: "translate(92.10217 44.546814)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.03052 4.93143L3.11997 1.63757L2.20874 4.93143L4.03052 4.93143ZM6.08157 6.88346C6.16256 7.158 6.03081 7.32133 5.75574 7.32133L4.89196 7.32133C4.6786 7.32133 4.49543 7.18887 4.44465 6.9754L4.17023 6.0097L1.93433 6.0097L1.65991 6.9754C1.60913 7.18887 1.42596 7.32133 1.21324 7.32133L0.348826 7.32133C0.0744019 7.32133 -0.0573477 7.158 0.0236285 6.88346L1.96518 0.386418C2.03588 0.153038 2.2396 0 2.48319 0L3.6728 0C3.91637 0 4.11946 0.153038 4.19079 0.386418L6.08157 6.88346Z",
    id: "path87",
    fill: "#65B731",
    fillRule: "evenodd",
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g89",
    transform: "translate(99.14801 44.54669)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.67938 5.02343C3.67938 4.41325 3.36447 4.16895 2.59195 4.16895L1.61572 4.16895L1.61572 6.0708L2.62216 6.0708C3.36447 6.0708 3.67938 5.83612 3.67938 5.21632L3.67938 5.02343ZM3.65881 2.06956C3.65881 1.4558 3.34389 1.24084 2.57138 1.24084L1.61572 1.24084L1.61572 3.06339L2.61189 3.06339C3.34389 3.06339 3.65881 2.85815 3.65881 2.24439L3.65881 2.06956ZM0.40682 7.32133C0.162599 7.32133 0 7.158 0 6.91433L0 0.406997C0 0.16266 0.162599 0 0.40682 0L2.51033 0C4.28928 0 5.26487 0.579946 5.26487 2.01374L5.26487 2.14553C5.26487 2.847 5.01038 3.31507 4.5637 3.61019C5.02065 3.92525 5.28544 4.38302 5.28544 5.1147L5.28544 5.27736C5.28544 6.73173 4.30921 7.32133 2.53089 7.32133L0.40682 7.32133Z",
    id: "path91",
    fill: "#65B731",
    fillRule: "evenodd",
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g93",
    transform: "translate(105.77374 44.546814)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.82178 6.91433C1.82178 7.158 1.63734 7.32133 1.36033 7.32133L0.461453 7.32133C0.184446 7.32133 0 7.158 0 6.91433L0 0.406997C0 0.162688 0.184446 0 0.461453 0L1.36033 0C1.63734 0 1.82178 0.162688 1.82178 0.406997L1.82178 6.91433Z",
    id: "path95",
    fill: "#65B731",
    fillRule: "evenodd",
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g97",
    transform: "translate(108.97534 44.546814)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.58363 6.91433C4.58363 7.158 4.42103 7.32133 4.17682 7.32133L0.406187 7.32133C0.162606 7.32133 0 7.158 0 6.91433L0 0.406997C0 0.162688 0.162606 0 0.406187 0L1.19926 0C1.44284 0 1.60607 0.162688 1.60607 0.406997L1.60607 6.07078L4.17682 6.07078C4.42103 6.07078 4.58363 6.23279 4.58363 6.47713L4.58363 6.91433Z",
    id: "path99",
    fill: "#65B731",
    fillRule: "evenodd",
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g101",
    transform: "translate(114.59479 44.546814)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.82178 6.91433C1.82178 7.158 1.63734 7.32133 1.36033 7.32133L0.461453 7.32133C0.184446 7.32133 0 7.158 0 6.91433L0 0.406997C0 0.162688 0.184446 0 0.461453 0L1.36033 0C1.63734 0 1.82178 0.162688 1.82178 0.406997L1.82178 6.91433Z",
    id: "path103",
    fill: "#65B731",
    fillRule: "evenodd",
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g105",
    transform: "translate(117.237305 44.546875)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.092 0.844195C5.092 1.08786 4.92939 1.25119 4.68518 1.25119L3.3336 1.25119L3.3336 6.91433C3.3336 7.158 3.17101 7.32066 2.92679 7.32066L2.13436 7.32066C1.89014 7.32066 1.72753 7.158 1.72753 6.91433L1.72753 1.25119L0.406827 1.25119C0.162606 1.25119 0 1.08786 0 0.844195L0 0.406997C0 0.16266 0.162606 0 0.406827 0L4.68518 0C4.92939 0 5.092 0.16266 5.092 0.406997L5.092 0.844195Z",
    id: "path107",
    fill: "#65B731",
    fillRule: "evenodd",
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g109",
    transform: "translate(122.7113 42.21869)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.03053 7.25961L3.11997 3.96576L2.20874 7.25961L4.03053 7.25961ZM3.75374 1.45128C3.88615 1.66936 3.80452 1.82254 3.56095 1.82254L3.01209 1.82254C2.88998 1.82254 2.75759 1.76735 2.68689 1.64796L1.79227 0.349202C1.63995 0.141484 1.71066 0 1.95488 0L2.70682 0C2.83921 0 2.94076 0.0655482 3.02173 0.18563L3.75374 1.45128ZM6.08157 9.21158C6.16255 9.48612 6.0308 9.64945 5.75573 9.64945L4.89196 9.64945C4.6786 9.64945 4.49543 9.51699 4.44466 9.30352L4.17023 8.33783L1.93433 8.33783L1.6599 9.30352C1.60913 9.51699 1.42597 9.64945 1.21324 9.64945L0.348826 9.64945C0.074402 9.64945 -0.0573616 9.48612 0.0236285 9.21158L1.96518 2.71454C2.03587 2.48116 2.23961 2.32812 2.48317 2.32812L3.67279 2.32812C3.91637 2.32812 4.11946 2.48116 4.19079 2.71454L6.08157 9.21158Z",
    id: "path111",
    fill: "#65B731",
    fillRule: "evenodd",
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g113",
    transform: "translate(132.12134 44.546814)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.03053 4.93143L3.11997 1.63757L2.20874 4.93143L4.03053 4.93143ZM6.08157 6.88346C6.16255 7.158 6.0308 7.32133 5.75573 7.32133L4.89196 7.32133C4.6786 7.32133 4.49543 7.18887 4.44466 6.9754L4.17023 6.0097L1.93433 6.0097L1.6599 6.9754C1.60913 7.18887 1.42597 7.32133 1.21324 7.32133L0.348826 7.32133C0.074402 7.32133 -0.0573616 7.158 0.0236285 6.88346L1.96518 0.386418C2.03587 0.153038 2.23961 0 2.48317 0L3.67279 0C3.91637 0 4.11946 0.153038 4.19079 0.386418L6.08157 6.88346Z",
    id: "path115",
    fill: "#65B731",
    fillRule: "evenodd",
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g117",
    transform: "translate(138.9129 44.41443)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.55986 6.37551C5.55986 6.50797 5.50909 6.61918 5.40754 6.71112C4.75715 7.26023 4.09647 7.58554 2.77511 7.58554C1.3522 7.58554 0 6.97604 0 5.12496L0 2.47085C0 0.630727 1.3522 0 2.77511 0C4.12667 0 5.3767 0.560006 5.53929 2.15646C5.57015 2.38984 5.39725 2.56281 5.14276 2.56281L4.24879 2.56281C4.05534 2.56281 3.95379 2.46056 3.93387 2.25805C3.86253 1.60674 3.50648 1.2409 2.77511 1.2409C1.97175 1.2409 1.60607 1.65816 1.60607 2.6033L1.60607 4.98288C1.60607 5.92866 1.97175 6.34528 2.77511 6.34528C3.43579 6.34528 3.89273 6.10097 3.95379 6.07074L3.95379 4.48458L3.34389 4.48458C3.15108 4.48458 3.03926 4.3727 3.03926 4.17918L3.03926 3.81334C3.03926 3.61981 3.15108 3.50793 3.34389 3.50793L5.15305 3.50793C5.39725 3.50793 5.55986 3.67126 5.55986 3.91493L5.55986 6.37551Z",
    id: "path119",
    fill: "#65B731",
    fillRule: "evenodd",
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g121",
    transform: "translate(145.96619 44.54712)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.63822 2.22656C3.63822 1.61639 3.35351 1.25055 2.59129 1.25055L1.60541 1.25055L1.60541 3.51761L2.59129 3.51761C3.35351 3.51761 3.63822 3.15177 3.63822 2.54226L3.63822 2.22656ZM5.2848 6.76129C5.43712 7.0969 5.27452 7.32066 4.90883 7.32066L4.08556 7.32066C3.87218 7.32066 3.67937 7.1882 3.60804 6.98569L2.80469 4.74819C2.69286 4.75848 2.54053 4.75848 2.42872 4.75848L1.60543 4.75848L1.60543 6.91366C1.60543 7.158 1.44284 7.32066 1.19926 7.32066L0.406188 7.32066C0.162606 7.32066 0 7.158 0 6.91366L0 0.406329C0 0.16266 0.162606 0 0.406188 0L2.50005 0C4.0245 0 5.24431 0.468067 5.24431 2.25741L5.24431 2.51137C5.24431 3.49767 4.87799 4.06733 4.29892 4.38236L5.2848 6.76129Z",
    id: "path123",
    fill: "#65B731",
    fillRule: "evenodd",
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g125",
    transform: "translate(152.41913 44.414978)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.9435 2.60269C3.9435 1.65755 3.57718 1.25055 2.77446 1.25055C1.97175 1.25055 1.60541 1.65755 1.60541 2.60269L1.60541 4.98226C1.60541 5.92805 1.97175 6.34467 2.77446 6.34467C3.57718 6.34467 3.9435 5.92805 3.9435 4.98226L3.9435 2.60269ZM5.54958 5.12432C5.54958 6.9754 4.19737 7.5849 2.77447 7.5849C1.35156 7.5849 0 6.9754 0 5.12432L0 2.46058C0 0.610147 1.35156 0 2.77447 0C4.19737 0 5.54958 0.610147 5.54958 2.46058L5.54958 5.12432Z",
    id: "path127",
    fill: "#65B731",
    fillRule: "evenodd",
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g129",
    transform: "translate(158.65527 44.546814)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.03052 4.93143L3.11997 1.63757L2.20874 4.93143L4.03052 4.93143ZM6.08157 6.88346C6.16254 7.158 6.03079 7.32133 5.75637 7.32133L4.89196 7.32133C4.67859 7.32133 4.49543 7.18887 4.44465 6.9754L4.17023 6.0097L1.93432 6.0097L1.6599 6.9754C1.60913 7.18887 1.42596 7.32133 1.21324 7.32133L0.348826 7.32133C0.0744019 7.32133 -0.0573616 7.158 0.0236285 6.88346L1.96518 0.386418C2.03587 0.153038 2.2396 0 2.48317 0L3.67278 0C3.91636 0 4.11946 0.153038 4.19079 0.386418L6.08157 6.88346Z",
    id: "path131",
    fill: "#65B731",
    fillRule: "evenodd",
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g133",
    transform: "translate(165.70148 44.546814)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.58363 6.91433C4.58363 7.158 4.42103 7.32133 4.17682 7.32133L0.406187 7.32133C0.162606 7.32133 0 7.158 0 6.91433L0 0.406997C0 0.162688 0.162606 0 0.406187 0L1.19926 0C1.44284 0 1.60607 0.162688 1.60607 0.406997L1.60607 6.07078L4.17682 6.07078C4.42103 6.07078 4.58363 6.23279 4.58363 6.47713L4.58363 6.91433Z",
    id: "path135",
    fill: "#65B731",
    fillRule: "evenodd",
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g137",
    transform: "translate(171.32092 44.546814)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.82178 6.91433C1.82178 7.158 1.63733 7.32133 1.36033 7.32133L0.461451 7.32133C0.184445 7.32133 0 7.158 0 6.91433L0 0.406997C0 0.162688 0.184445 0 0.461451 0L1.36033 0C1.63733 0 1.82178 0.162688 1.82178 0.406997L1.82178 6.91433Z",
    id: "path139",
    fill: "#65B731",
    fillRule: "evenodd",
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g141",
    transform: "translate(174.52185 44.546814)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.95836 6.91433C7.95836 7.158 7.79575 7.32133 7.55155 7.32133L6.7591 7.32133C6.5149 7.32133 6.35229 7.158 6.35229 6.91433L6.35229 1.70833L4.70573 6.98569C4.63504 7.18887 4.46215 7.32133 4.24879 7.32133L3.69993 7.32133C3.48656 7.32133 3.31368 7.18887 3.24234 6.98569L1.60607 1.72891L1.60607 6.91433C1.60607 7.158 1.44346 7.32133 1.1999 7.32133L0.406813 7.32133C0.163245 7.32133 0 7.158 0 6.91433L0 0.406997C0 0.162688 0.163245 0 0.406813 0L2.08359 0C2.29695 0 2.46983 0.132458 2.54117 0.336276L3.97436 4.94175L5.40754 0.336276C5.47825 0.132458 5.65112 0 5.86449 0L7.55155 0C7.79575 0 7.95836 0.162688 7.95836 0.406997L7.95836 6.91433Z",
    id: "path143",
    fill: "#65B731",
    fillRule: "evenodd",
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g145",
    transform: "translate(184.07477 44.546814)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.4416 6.91433C4.4416 7.158 4.279 7.32133 4.03479 7.32133L0.406827 7.32133C0.162606 7.32133 0 7.158 0 6.91433L0 0.406997C0 0.162688 0.162606 0 0.406827 0L4.02451 0C4.26873 0 4.43132 0.162688 4.43132 0.406997L4.43132 0.844195C4.43132 1.08853 4.26873 1.25119 4.02451 1.25119L1.60607 1.25119L1.60607 3.01995L3.82205 3.01995C4.06563 3.01995 4.22824 3.18264 4.22824 3.42695L4.22824 3.83395C4.22824 4.07762 4.06563 4.24028 3.82205 4.24028L1.60607 4.24028L1.60607 6.07078L4.03479 6.07078C4.279 6.07078 4.4416 6.23279 4.4416 6.47713L4.4416 6.91433Z",
    id: "path147",
    fill: "#65B731",
    fillRule: "evenodd",
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g149",
    transform: "translate(189.7555 44.546814)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.53929 6.91433C5.53929 7.158 5.37669 7.32133 5.13248 7.32133L4.20829 7.32133C4.01484 7.32133 3.85225 7.20945 3.77062 7.04679L1.60607 2.73512L1.60607 6.91433C1.60607 7.158 1.44346 7.32133 1.19924 7.32133L0.406813 7.32133C0.162592 7.32133 0 7.158 0 6.91433L0 0.406997C0 0.162688 0.162592 0 0.406813 0L1.35156 0C1.54501 0 1.7076 0.111879 1.78923 0.274539L3.93322 4.57591L3.93322 0.406997C3.93322 0.162688 4.09583 0 4.34004 0L5.13246 0C5.37669 0 5.53929 0.162688 5.53929 0.406997L5.53929 6.91433Z",
    id: "path151",
    fill: "#65B731",
    fillRule: "evenodd",
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g153",
    transform: "translate(196.33087 44.546875)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.092 0.844195C5.092 1.08786 4.92939 1.25119 4.68518 1.25119L3.3336 1.25119L3.3336 6.91433C3.3336 7.158 3.17101 7.32066 2.92679 7.32066L2.13436 7.32066C1.89014 7.32066 1.72753 7.158 1.72753 6.91433L1.72753 1.25119L0.406827 1.25119C0.162606 1.25119 0 1.08786 0 0.844195L0 0.406997C0 0.16266 0.162606 0 0.406827 0L4.68518 0C4.92939 0 5.092 0.16266 5.092 0.406997L5.092 0.844195Z",
    id: "path155",
    fill: "#65B731",
    fillRule: "evenodd",
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g157",
    transform: "translate(201.80487 44.546814)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.03052 4.93143L3.11997 1.63757L2.20874 4.93143L4.03052 4.93143ZM6.08157 6.88346C6.16254 7.158 6.03079 7.32133 5.75637 7.32133L4.89196 7.32133C4.67859 7.32133 4.49543 7.18887 4.44465 6.9754L4.17023 6.0097L1.93432 6.0097L1.6599 6.9754C1.60913 7.18887 1.42596 7.32133 1.21324 7.32133L0.348826 7.32133C0.0744019 7.32133 -0.0573616 7.158 0.0236285 6.88346L1.96518 0.386418C2.03587 0.153038 2.2396 0 2.48317 0L3.67278 0C3.91636 0 4.11946 0.153038 4.19079 0.386418L6.08157 6.88346Z",
    id: "path159",
    fill: "#65B731",
    fillRule: "evenodd",
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g161",
    transform: "translate(208.85107 44.54712)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.63822 2.22656C3.63822 1.61639 3.35351 1.25055 2.59129 1.25055L1.60541 1.25055L1.60541 3.51761L2.59129 3.51761C3.35351 3.51761 3.63822 3.15177 3.63822 2.54226L3.63822 2.22656ZM5.2848 6.76129C5.43712 7.0969 5.27452 7.32066 4.90883 7.32066L4.08556 7.32066C3.87218 7.32066 3.67937 7.1882 3.60804 6.98569L2.80469 4.74819C2.69286 4.75848 2.54053 4.75848 2.42872 4.75848L1.60543 4.75848L1.60543 6.91366C1.60543 7.158 1.44284 7.32066 1.19926 7.32066L0.406188 7.32066C0.162606 7.32066 0 7.158 0 6.91366L0 0.406329C0 0.16266 0.162606 0 0.406188 0L2.50005 0C4.0245 0 5.24431 0.468067 5.24431 2.25741L5.24431 2.51137C5.24431 3.49767 4.87799 4.06733 4.29892 4.38236L5.2848 6.76129Z",
    id: "path163",
    fill: "#65B731",
    fillRule: "evenodd",
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g165",
    transform: "translate(215.55786 44.546814)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.4416 6.91433C4.4416 7.158 4.27901 7.32133 4.03478 7.32133L0.406827 7.32133C0.162606 7.32133 0 7.158 0 6.91433L0 0.406997C0 0.162688 0.162606 0 0.406827 0L4.02449 0C4.26873 0 4.43132 0.162688 4.43132 0.406997L4.43132 0.844195C4.43132 1.08853 4.26873 1.25119 4.02449 1.25119L1.60607 1.25119L1.60607 3.01995L3.82207 3.01995C4.06563 3.01995 4.22823 3.18264 4.22823 3.42695L4.22823 3.83395C4.22823 4.07762 4.06563 4.24028 3.82207 4.24028L1.60607 4.24028L1.60607 6.07078L4.03478 6.07078C4.27901 6.07078 4.4416 6.23279 4.4416 6.47713L4.4416 6.91433Z",
    id: "path167",
    fill: "#65B731",
    fillRule: "evenodd",
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g169"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.4669 34.3498L20.4592 34.3408L20.4592 21.6373C20.4592 21.1589 20.3872 19.9785 20.3474 19.6712C20.3448 19.6531 20.3429 19.6352 20.341 19.6178C18.9586 9.17624 10.5696 0.974067 0 0C3.82333 3.06945 6.24175 7.78166 6.24175 12.9857L6.24947 12.9954L6.30538 33.9968C6.30538 38.4911 9.02522 42.4098 12.954 43.9909C15.6963 45.0948 18.2638 44.6705 19.0614 44.4647C20.3995 44.1201 21.654 43.5434 22.7967 42.8194C21.3166 40.3247 20.4669 37.425 20.4669 34.3498",
    id: "path171",
    fill: "#65B731",
    fillRule: "evenodd",
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g173",
    transform: "translate(24.034546 12.365845)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.6959 0L27.6708 0.00514482C22.8719 0.973427 19.3898 5.23364 19.3898 10.133L19.384 17.0588C19.384 29.95 12.9244 37.8513 1.19539 39.305C1.02251 39.3269 0.611192 39.3777 0 39.4085C0.664537 39.4548 1.32714 39.4619 1.97176 39.4619L2.62986 39.4613C15.0395 39.4613 23.377 30.4914 23.377 17.1405L23.3648 10.133C23.3648 7.65694 24.6251 4.80737 27.4394 3.99018L29.4446 1.77582L27.6959 0Z",
    id: "path175",
    fill: "#3352AB",
    fillRule: "evenodd",
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g177",
    transform: "translate(20.633728 6.188629)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.0211 0C22.8404 1.04673 16.677 8.05364 16.677 16.3143L16.7227 24.2683C16.7227 33.7923 12.5696 40 4.47116 42.5114C3.68066 42.7564 1.81494 43.1692 0 43.1859C2.94735 43.6964 5.41976 43.2058 5.94612 43.1049C9.6332 42.3989 12.693 40.8995 15.0549 38.6415C17.544 36.0253 19.296 32.5752 20.1192 28.668C20.4438 26.9288 20.6083 25.1009 20.6083 23.2357L20.6135 16.3098C20.6135 10.3779 24.8308 5.22143 30.6413 4.04739L30.6805 4.03968L32.8406 1.84656L31.0211 0Z",
    id: "path179",
    fill: "#3352AB",
    fillRule: "evenodd",
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g181",
    transform: "translate(17.853333 0.0020141602)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.7229 0C22.2652 1.10202 13.3023 10.9662 13.3023 22.4969L13.3023 31.5182C13.3023 34.3517 13.1223 36.8862 11.7123 39.4195C9.30093 43.7523 4.97566 46.3531 0 47.0822C0.4788 47.1278 0.846417 47.1503 1.11892 47.1503C1.82972 47.1503 3.01998 47.1503 4.18966 46.9189C7.50078 46.265 9.96097 45.2228 11.9269 43.6417C13.8132 42.0768 15.2303 40.0888 16.1391 37.7343C16.927 35.6248 17.3261 32.291 17.3261 29.5752L17.2805 22.5072C17.2805 13.1542 24.2523 5.22271 33.5559 4.02361L35.6208 1.92694L33.7229 0Z",
    id: "path183",
    fill: "#3352AB",
    fillRule: "evenodd",
    stroke: "none"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoUnblended);
export default __webpack_public_path__ + "static/media/logo_unblended.03d1b72f4ccb6fac67684d92b439e08b.svg";
export { ForwardRef as ReactComponent };